<template>
  <div class="update-mgt-page">
    <div class="global-header-wrap">
      <span v-if="!$route.query.id">{{ $t('commonMsg.new') }}</span>
      <span v-else>{{ $t('commonMsg.edit') }}</span>
      <div>
        <button class="global-button-style" @click="$router.back()">
          {{ $t('commonMsg.back') }}
        </button>
        <button class="global-button-style" @click="submitForm('ruleForm')">
          {{ $t('commonMsg.save') }}
        </button>
      </div>
    </div>
    <el-card
      class="app-table-container"
      :body-style="{ padding: '20px' }"
      v-bar
    >
      <div class="body-wrap params-wrap">
        <el-form
          label-width="120px"
          :model="service"
          @submit.native.prevent
          ref="ruleForm"
          label-position="top"
          :rules="rules"
        >
          <el-form-item label="配置类型" prop="configType">
            <el-input
              v-model="service.configType"
              class="fl"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="是否启用">
            <el-radio-group v-model="service.configStatus">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="语言" prop="clusterLang">
            <el-input
              v-model="service.clusterLang"
              class="fl"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="Key" prop="key">
            <el-input v-model="service.key" class="fl" clearable></el-input>
          </el-form-item>
          <el-form-item label="内容" prop="content">
            <el-input v-model="service.content" class="fl" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
export default {
  computed: {},
  data() {
    return {
      service: {
        configType: '',
        clusterLang: '',
        configStatus: 1,
        key: '',
        content: '',
        dbId: 'CloudConfig',
        user: 'onyx_admin',
        msgStatus: 0,
        msgType: 4
      },
      rules: {
        // name: [
        //   {
        //     required: true,
        //     message:
        //       '输入默认名字，设备的语言在多语言匹配不到，就会显示默认名字',
        //     trigger: 'blur'
        //   }
        // ],
      }
    }
  },
  methods: {
    async getDetails() {
      let res = await this.$store.dispatch(
        'getServiceConfigDetails',
        this.$route.query.id
      )
      this.service = Object.assign(this.service, res[0])
    },

    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (this.$route.query.id) {
            this.edit()
          } else {
            this.create()
          }
        } else {
          return false
        }
      })
    },

    async create() {
      this.service.createdAt = new Date()
      this.service.updatedAt = new Date()
      this.service.uniqueId = uuidv4()
      this.service._id = this.service.uniqueId
      await this.$store.dispatch('updateServiceConfigItem', this.service)
      this.$message({
        type: 'success',
        message: this.$t('alertMsg.addSuccess')
      })
      this.$router.back()
    },

    async edit() {
      await this.$store.dispatch('updateServiceConfigItem', this.service)
      this.$message({
        type: 'success',
        message: this.$t('alertMsg.editSuccess')
      })
      this.$router.back()
    }
  },
  async mounted() {
    if (!this.$route.query.id) return
    this.getDetails()
  }
}
</script>

<style lang="scss">
.update-mgt-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .body-wrap {
    /* height: 100%; */
    flex: 1;
    overflow: hidden;
    &.params-wrap {
      .parms-list + .parms-list {
        margin-top: 10px;
      }
      .parms-list {
        display: flex;
        > .el-input {
          width: 40%;
          max-width: 300px;
          margin-right: 10px;
        }
        > span {
          width: 30px;
          height: 35px;
          line-height: 32px;
          text-align: center;
          display: inline-block;
          font-size: 20px;
          vertical-align: bottom;
          cursor: pointer;
          color: #555;
        }
      }
    }
    .el-form {
      width: 80%;
      margin: 10px auto;
      .global-button-style {
        width: 100%;
        margin: 0;
      }
      .update-import-btn {
        margin-top: 10px;
      }
      .update-upload-progress {
        display: flex;
        align-items: center;
        > .el-progress__text {
          /* width: 100px; */
        }
      }
    }
  }
}
</style>
